import React from "react";

const HomeNumbers = () => {
  return (
    <section
      className="py-20 xl:py-24 bg-white bg-center"
      style={{ backgroundImage: "url('/img/pattern-white.svg')" }}
    >
      <div className="container">
        <div className="text-center">
          <span className="inline-block py-px px-2 mb-4 text-xs leading-5 text-blue-500 bg-blue-100 uppercase rounded-full">
            数据统计
          </span>
          <h2 className="mb-4 text-2xl md:text-3xl !leading-tight text-slate-800 font-bold tracking-tight">
            AI智能服务的强大实力
          </h2>
          <p className="mb-24 text-base md:text-lg text-slate-500">
            我们的AI智能软件服务已嵌入到数千款产品中，帮助企业提升产品智能化水平，降低开发成本，提高用户体验。
          </p>
        </div>
        <div className="sm:grid sm:grid-cols-2 lg:grid-cols-4 -mx-4 text-center text-slate-800">
          <div className=" px-4 mb-8">
            <p className="py-4 text-3xl font-bold text-blue-600">10.000+</p>
            <h3 className="text-slate-500">已优化产品</h3>
          </div>
          <div className=" px-4 mb-8">
            <p className="py-4 text-3xl font-bold text-blue-600">500.000+</p>
            <h3 className="text-slate-500">管理设备数量</h3>
          </div>
          <div className=" px-4 mb-8">
            <p className="py-4 text-3xl font-bold text-blue-600">100.000+</p>
            <h3 className="text-slate-500">每年节省分析时间</h3>
          </div>
          <div className=" px-4 mb-8 md:mb-0">
            <p className="py-4 text-3xl font-bold text-blue-600">5.000+</p>
            <h3 className="text-slate-500">活跃用户数量</h3>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeNumbers;
